import BankCardWarningIcon from "@/assets/colorable/bank_card_warning.svg?react";
import Button from "@/components/Common/Button";
import type {InvoiceSerializer} from "@/generated/DjangoTypes";
import {getPaymentDeadline, usePayment} from "@/hooks/usePayment";
import {settingsModalAtom} from "@/store/jotaiAtoms";
import type {TSettingsScope} from "@/store/types";
import {useSetAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const PaymentFailedBanner: FC<{invoices: InvoiceSerializer[]; scope: TSettingsScope}> = ({invoices, scope}) => {
  const {t} = useTranslation("settings");
  const {getTranslatedErrorMessage} = usePayment();
  const setSettingsModal = useSetAtom(settingsModalAtom);
  const reason = invoices.map(invoice => getTranslatedErrorMessage(invoice)).find(Boolean);
  const deadline = getPaymentDeadline(invoices);

  return (
    <div className="md:border-neutral-grey-light-dark flex flex-col gap-3 md:flex-row md:items-stretch md:gap-5 md:overflow-hidden md:rounded-lg md:border md:bg-white md:pr-1.5">
      <div className="border-neutral-grey-light-dark flex min-h-15 flex-1 items-stretch gap-3 overflow-hidden rounded-lg border bg-white md:overflow-visible md:rounded-none md:border-0">
        <div className="bg-danger-light-red flex w-12 shrink-0 items-center justify-center md:w-15">
          <BankCardWarningIcon className="text-danger-medium-red h-5 w-6 shrink-0" />
        </div>
        <div className="flex flex-col justify-center gap-1 py-3 pr-3 md:pr-0">
          <span className="text-neutral-black px-0.5 text-xs">{t("payment_failed_because")}</span>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            {reason && (
              <span className="bg-danger-light-red text-neutral-black text-2xs flex min-h-6 items-center rounded-full px-2 font-semibold uppercase">
                {reason}
              </span>
            )}
            {deadline && (
              <span className="border-neutral-grey-light-dark text-neutral-black text-2xs flex min-h-6 items-center rounded-full border bg-white px-2 font-semibold uppercase">
                {t("make_payment_by", {date: deadline.format("MMMM Do")})}
              </span>
            )}
          </div>
        </div>
      </div>
      <Button
        buttonStyle="White"
        className="h-12 md:w-fit md:shrink-0 md:self-center md:px-8"
        onClick={() => setSettingsModal({scope, section: "billing", subview: {type: "payment_failed"}})}>
        {t("review_payment")}
      </Button>
    </div>
  );
};

export default PaymentFailedBanner;
